import { useParams } from 'react-router-dom'
import { Stack, Title, Group, TextInput, Select, Switch } from '@mantine/core'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { tracesApi } from '@/api'
import { TraceList } from '@/components/TraceList'
import { TraceDetail } from '@/components/TraceDetail'
import { ServiceDependencyGraph } from '@/components/ServiceDependencyGraph'
import { IconSearch } from '@tabler/icons-react'

export function Traces() {
  const { id } = useParams()
  const [service, setService] = useState('')
  const [errorsOnly, setErrorsOnly] = useState(false)
  const [showDependencies, setShowDependencies] = useState(false)

  const { data: traces = [], isLoading } = useQuery({
    queryKey: ['traces', { service, errors_only: errorsOnly }],
    queryFn: async () => {
      const { data } = await tracesApi.list({
        service: service || undefined,
        errors_only: errorsOnly,
        limit: 100,
      })
      return data
    },
    refetchInterval: 30000,
  })

  const { data: dependencies = [] } = useQuery({
    queryKey: ['trace-dependencies'],
    queryFn: async () => {
      const { data } = await tracesApi.getDependencies()
      return data
    },
    enabled: showDependencies,
    refetchInterval: 60000,
  })

  if (id) {
    return <TraceDetail traceId={id} />
  }

  return (
    <Stack gap="lg">
      <Group justify="space-between">
        <Title order={2}>Distributed Traces</Title>
        <Switch
          label="Show Dependencies"
          checked={showDependencies}
          onChange={(e) => setShowDependencies(e.currentTarget.checked)}
        />
      </Group>

      <Group>
        <TextInput
          placeholder="Filter by service..."
          leftSection={<IconSearch size={18} />}
          value={service}
          onChange={(e) => setService(e.currentTarget.value)}
          w={300}
        />
        <Switch
          label="Errors only"
          checked={errorsOnly}
          onChange={(e) => setErrorsOnly(e.currentTarget.checked)}
        />
      </Group>

      {showDependencies ? (
        <ServiceDependencyGraph dependencies={dependencies} />
      ) : (
        <TraceList traces={traces} loading={isLoading} />
      )}
    </Stack>
  )
}